import {Order} from './Order';
import {SelectColumn} from './SelectColumn';

export class QuerySettings
{
    constructor(
            public readonly offset:number, 
            public readonly limit:number, 
            public readonly orderBy:Order[], 
            public readonly columns:SelectColumn[], 
            public readonly groupBy:string[]
        )
    {}
}
